import { fetchZips } from '@/api/zips';

export async function fetch({ commit, state }) {
   if (state.loaded) {
      return Promise.resolve();
   }
   return fetchZips()
      .then(zips => {
         commit('setZips', zips);
         commit('setLoaded', true);
      });
}
